import { render } from "./MiniProgramVipRecharge.vue?vue&type=template&id=28e6e695&scoped=true"
import script from "./MiniProgramVipRecharge.vue?vue&type=script&lang=js"
export * from "./MiniProgramVipRecharge.vue?vue&type=script&lang=js"

import "./MiniProgramVipRecharge.vue?vue&type=style&index=0&id=28e6e695&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e6e695"]])

export default __exports__